import { acceptHMRUpdate, defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  persist: false,

  state: () => ({
    pageviews: 0,
  }),

  getters: {
    initialLoad() {
      return this.pageviews === 0
    }
  },
  
  actions: {
    addPageview() {
      this.pageviews++
    },
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
